<script setup lang="ts">
import type { ICommodity, ICrypto, IRealEstate, IStock } from '~/@types/assets'
import AssetsAdapter from '@adapters/AssetsAdapter'
import { Icon } from '@iconify/vue'
import { storeToRefs } from 'pinia'
import { ref } from 'vue'
import AssetView from '~/components/assets/AssetView.vue'
import { useAssetsWatchingStore } from '~/stores/assetsWatching'

const assetWatchStore = useAssetsWatchingStore()
const { assetsWatching } = storeToRefs(assetWatchStore)

const isViewOpen = ref(false)
const isLoading = ref(false)
const asset = ref<IStock | IRealEstate | ICrypto | ICommodity | null>(null)

async function openAsset(id: string): Promise<void> {
  isLoading.value = true
  isViewOpen.value = true
  asset.value = await AssetsAdapter.get(id)
  isLoading.value = false
}

function viewClosed() {
  isLoading.value = false
  asset.value = null
  isViewOpen.value = false
}
</script>

<template>
  <section>
    <template v-if="assetsWatching.length > 0">
      <AssetItem v-for="assetItem in assetsWatching" :key="`watching-${assetItem.id}`" class="mb-3" :asset="assetItem" @asset-click="openAsset" />
      <AssetView :is-open="isViewOpen" :is-loading="isLoading" :asset="asset" @closed="viewClosed" />
    </template>
    <template v-else>
      <div class="text-center py-12">
        <div class="flex justify-center">
          <Icon icon="mdi:package-variant-closed" class="text-4xl text-gray-700 mb-3" />
        </div>
        <p class="text-gray-500">
          No assets being watched
        </p>
      </div>
    </template>
  </section>
</template>
